import React from "react";
import Header from "../../components/orrbiitheader";
import Footer from "../../components/footerorrbiit";
import { Link } from "react-router-dom";

export default function TermsPage() {
  return (
    <>
      <Header />

      <div
        style={{
          backgroundColor: "#f7ead7",
          minHeight: "100vh",
          padding: "20px 0",
        }}
      >
        <div className="container" style={{ maxWidth: "850px" }}>

          {/* TITLE */}
          <div className="text-center mb-3">
            <h1 style={{ fontWeight: "800", marginBottom: "4px" }}>
              Terms & Conditions
            </h1>

            <p style={{ fontSize: "28px", fontWeight: "600", marginBottom: "4px" }}>
              ORRBIIT GROUP
            </p>

            <p style={{ fontSize: "12px", color: "#777" }}>
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>

          {/* INTRO */}
          <section className="mb-3">
            <p style={{ color: "#444", lineHeight: "1.7" }}>
              These Terms and Conditions govern your use of services provided by Orrbiit Group.
              By accessing, browsing, or using any of our services, you acknowledge that you have read,
              understood, and agreed to be bound by these terms. If you do not agree, you should not
              use our services.
            </p>
          </section>

          {/* USER INFO */}
          <section className="mb-3">
            <h3 className="mb-1">User Information</h3>
            <p style={{ color: "#444", lineHeight: "1.7" }}>
              Users are required to provide accurate, complete, and up-to-date information while
              booking any service. Providing false, misleading, or incomplete information may result
              in cancellation of bookings without prior notice. Orrbiit shall not be responsible for
              any inconvenience, loss, or issue arising due to incorrect information submitted by users.
            </p>
          </section>

          {/* BOOKING */}
          <section className="mb-3">
            <h3 className="mb-1">Booking & Communication</h3>
            <p style={{ color: "#444", lineHeight: "1.7" }}>
              Bookings can be made through our official website or directly through our team based on
              user requests. Customers may also contact us via WhatsApp or other official communication
              channels for assistance. Orrbiit reserves the right to accept or decline booking requests
              based on operational feasibility.
            </p>
          </section>

          {/* PRICING */}
          <section className="mb-3">
            <h3 className="mb-1">Pricing & Availability</h3>
            <p style={{ color: "#444", lineHeight: "1.7" }}>
              Prices may vary depending on service type, location, timing, and availability. Orrbiit
              reserves the right to modify pricing without prior notice. Final pricing will be confirmed
              at the time of booking.
            </p>
          </section>

          {/* PAYMENTS */}
          <section className="mb-3">
            <h3 className="mb-1">Payments, Refunds & Support</h3>
            <p style={{ color: "#444", lineHeight: "1.7" }}>
              For payment-related issues or refund requests, users must contact our official support
              channels via phone or email. Each request will be reviewed carefully, and resolutions
              will typically be provided within 48 hours. Refund eligibility depends on the nature of
              the issue, service conditions, and applicable policies.
            </p>
          </section>

          {/* CANCELLATION */}
          <section className="mb-3">
            <h3 className="mb-1">Cancellation Policy</h3>
            <p style={{ color: "#444", lineHeight: "1.7" }}>
              Bookings may be cancelled or rescheduled based on availability, operational constraints,
              or user requests. Cancellation terms may vary depending on the specific service.
              Orrbiit reserves the right to cancel bookings in case of unforeseen circumstances.
            </p>
          </section>

          {/* LIABILITY */}
          <section className="mb-3">
            <h3 className="mb-1">Service Responsibility & Liability</h3>
            <p style={{ color: "#444", lineHeight: "1.7" }}>
              Orrbiit strives to provide reliable and high-quality services. However, we shall not be
              held liable for any indirect, incidental, or consequential damages arising from the use
              of our services. Users agree to use services at their own discretion.
            </p>
          </section>

          {/* MISUSE */}
          <section className="mb-3">
            <h3 className="mb-1">Use of Services</h3>
            <p style={{ color: "#444", lineHeight: "1.7" }}>
              Any misuse, fraudulent activity, or violation of applicable laws may result in suspension
              or permanent termination of access to Orrbiit services.
            </p>
          </section>

          {/* COMPANY TERMS */}
          <section className="mb-1">
            <h3 className="mb-1">Service-Specific Terms</h3>

            <p style={{ color: "#444", lineHeight: "1.7" }}>
              Each Orrbiit service operates under its own policies tailored to its nature:
            </p>

            <div style={{ marginBottom: "12px" }}>
              <p style={{ marginBottom: "3px", color: "#444" }}>
                <strong>Orrbiit Elegance:</strong> Covers home beauty services, hygiene standards,
                booking flow, and service quality expectations.
              </p>
              <Link to="/orrbiitelegance/terms" style={{ fontWeight: "500" }}>
                Read full Elegance Terms →
              </Link>
            </div>

            <div style={{ marginBottom: "12px" }}>
              <p style={{ marginBottom: "3px", color: "#444" }}>
                <strong>Orrbiit Go:</strong> Includes travel bookings, pricing logic, driver conduct,
                and journey responsibilities.
              </p>
              <Link to="/orrbiitgo/terms" style={{ fontWeight: "500" }}>
                Read full Go Terms →
              </Link>
            </div>

            <div>
              <p style={{ marginBottom: "3px", color: "#444" }}>
                <strong>Orrbiit Relief:</strong> Covers donations, transparency, fund usage, and
                participation guidelines.
              </p>
              <Link to="/orrbiitrelief/terms" style={{ fontWeight: "500" }}>
                Read full Relief Terms →
              </Link>
            </div>
          </section>

          {/* CHANGES */}
          <section className="mb-3">
            <h3 className="mb-1">Changes to Terms</h3>
            <p style={{ color: "#444", lineHeight: "1.7" }}>
              Orrbiit reserves the right to update or modify these Terms and Conditions at any time.
              Continued use of services constitutes acceptance of the updated terms.
            </p>
          </section>

          {/* CONTACT */}
          <section className="mb-2">
            <h3 className="mb-1">Contact Us</h3>
            <p style={{ color: "#444", lineHeight: "1.7" }}>
              For any queries, contact us at:<br />
              Email: info@orbiit.com<br />
              Phone: +91 9836904698
            </p>
          </section>

        </div>
      </div>

      <Footer />
    </>
  );
}